// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"PageDisclaimer_disclaimer__a8ajh"};